import React from 'react';
import {Link} from 'react-router-dom';
import i18n from 'i18n-react';
import logo from '../images/logo.png';
import producto1 from '../images/producto1.png';
import producto2 from '../images/producto2.png';
import producto3 from '../images/producto3.png';
import producto4 from '../images/producto4.png';
export default class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      locale: this.props.locale,
      isMenuProductosOn: false,
      productos: [producto1, producto2, producto3, producto4]
    };
    this.openMenuProductosHandle = this.openMenuProductosHandle.bind(this);
  }

  render() {
    return (
      <header>
        <div className="container">
          <img src={logo} className="logo" alt="Las2vacas"/>
          <div className="menus">
            <nav className="menu">
              <ul>
                <li><Link to="#">
                  <i18n.span text={{key: this.state.locale + ".menu.menu1"}}/>
                </Link></li>
                <li className={(this.state.isMenuProductosOn) ? 'activo' : ''}>
                  <Link to="#" onClick={this.openMenuProductosHandle}>
                    <i18n.span text={{key: this.state.locale + ".menu.menu2"}}/>
                  </Link></li>
                <li><Link to="#">
                  <i18n.span text={{key: this.state.locale + ".menu.menu3"}}/>
                </Link></li>
                <li><Link to="#">
                  <i18n.span text={{key: this.state.locale + ".menu.menu4"}}/>
                </Link></li>
              </ul>
            </nav>
            <nav className="locales">
              <ul>
                <li><Link to="./" className={(this.state.locale === 'es') ? 'activo' : ''}>ES</Link></li>
                <li><Link to="./cat" className={(this.state.locale === 'cat') ? 'activo' : ''}>CAT</Link></li>
              </ul>
            </nav>
            <nav className="rrss">
              <ul>
                <li>
                  <Link to="https://www.facebook.com/las2vacas" target="_blank"><i className="fa fa-facebook" aria-hidden="true"></i></Link>
                </li>
                <li>
                  <Link to="https://www.instagram.com/las2vacas/" target="_blank"><i className="fa fa-instagram" aria-hidden="true"></i></Link>
                </li>
                <li>
                  <Link to="https://twitter.com/las2vacas" target="_blank"><i className="fa fa-twitter" aria-hidden="true"></i></Link>
                </li>
                <li>
                  <Link to="https://www.youtube.com/channel/UColqKsuVEhl76oPfPdm_tkw" target="_blank"><i className="fa fa-youtube" aria-hidden="true"></i></Link>
                </li>
              </ul>
            </nav>
          </div>
          <div className={(this.state.isMenuProductosOn) ? 'productos activo' : 'productos'}>
            <nav>
              <ul>
                { this.renderProductos() }
              </ul>
            </nav>
          </div>
        </div>
      </header>
    );
  }

  renderProductos() {
    return this.state.productos.map((producto, index) => (
      <li key={index} className={'producto' + (index + 1)}>
        <figure>
          <Link to="#"> <img src={producto} className="producto" alt=""/>
            <figcaption>
              <i18n.span text={{key: this.state.locale + ".menu.productos.producto" + (index + 1)}}/>
            </figcaption>
          </Link>
        </figure>
      </li>
    ));
  }

  openMenuProductosHandle(event) {
    event.preventDefault();
    this.setState({isMenuProductosOn: ! this.state.isMenuProductosOn});
  }
}


// WEBPACK FOOTER //
// ./src/component/Header.js